"use strict";

var _construct = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Resolves to the given item in the path data.
 * For example, new DataHandler({}, 'foo', 'bar')
 * will return pathData.foo.bar.
 *
 * Resolution can optionally be async,
 * and/or be behind a function call.
 */

var DataHandler =
/*#__PURE__*/
function () {
  function DataHandler(options) {
    _classCallCheck(this, DataHandler);

    this._isAsync = options.async;
    this._isFunction = options.function;

    for (var _len = arguments.length, dataProperties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      dataProperties[_key - 1] = arguments[_key];
    }

    this._dataProperties = dataProperties;
  }

  _createClass(DataHandler, [{
    key: "handle",

    /**
     * Resolve the data path.
     */
    value: function handle(pathData) {
      var _this = this;

      return !this._isFunction ? this._resolveDataPath(pathData) : function () {
        return _this._resolveDataPath(pathData);
      };
    }
  }, {
    key: "_resolveDataPath",
    value: function _resolveDataPath(data) {
      var _this2 = this;

      // Resolve synchronous property access
      if (!this._isAsync) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this._dataProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var property = _step.value;
            data = data && data[property];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return data;
      } // Resolve asynchronous property access


      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(resolve) {
          var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _property;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context.prev = 3;
                  _iterator2 = _this2._dataProperties[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context.next = 16;
                    break;
                  }

                  _property = _step2.value;
                  _context.t0 = data;

                  if (!_context.t0) {
                    _context.next = 12;
                    break;
                  }

                  _context.next = 11;
                  return data[_property];

                case 11:
                  _context.t0 = _context.sent;

                case 12:
                  data = _context.t0;

                case 13:
                  _iteratorNormalCompletion2 = true;
                  _context.next = 5;
                  break;

                case 16:
                  _context.next = 22;
                  break;

                case 18:
                  _context.prev = 18;
                  _context.t1 = _context["catch"](3);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context.t1;

                case 22:
                  _context.prev = 22;
                  _context.prev = 23;

                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }

                case 25:
                  _context.prev = 25;

                  if (!_didIteratorError2) {
                    _context.next = 28;
                    break;
                  }

                  throw _iteratorError2;

                case 28:
                  return _context.finish(25);

                case 29:
                  return _context.finish(22);

                case 30:
                  resolve(data);

                case 31:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[3, 18, 22, 30], [23,, 25, 29]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }], [{
    key: "sync",
    value: function sync() {
      for (var _len2 = arguments.length, dataProperties = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dataProperties[_key2] = arguments[_key2];
      }

      return _construct(DataHandler, [{
        async: false
      }].concat(dataProperties));
    }
  }, {
    key: "syncFunction",
    value: function syncFunction() {
      for (var _len3 = arguments.length, dataProperties = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        dataProperties[_key3] = arguments[_key3];
      }

      return _construct(DataHandler, [{
        async: false,
        function: true
      }].concat(dataProperties));
    }
  }, {
    key: "async",
    value: function async() {
      for (var _len4 = arguments.length, dataProperties = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        dataProperties[_key4] = arguments[_key4];
      }

      return _construct(DataHandler, [{
        async: true
      }].concat(dataProperties));
    }
  }, {
    key: "asyncFunction",
    value: function asyncFunction() {
      for (var _len5 = arguments.length, dataProperties = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        dataProperties[_key5] = arguments[_key5];
      }

      return _construct(DataHandler, [{
        async: true,
        function: true
      }].concat(dataProperties));
    }
  }]);

  return DataHandler;
}();

exports.default = DataHandler;